import React from 'react';
import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField } from 'react/components/fields';

const PaymentMethodTypeCrud = (props) => (
  <BaseCrud updateMethod="PATCH" tabName="PaymentMethodType.title" {...props}>
    <FormSection title="PaymentMethodType.section.general.title">
      <FormSectionColumn>
        <TextField
          label="PaymentMethodType.field.key"
          name="key"
          required
        />
      </FormSectionColumn>
    </FormSection>
  </BaseCrud>
);

export default PaymentMethodTypeCrud;
